<template>
  <div id="app">
    <VideoCall/>
  </div>
</template>

<script>
import VideoCall from "./components/index.vue";
export default {
  name: "App",
  components: {
    VideoCall
  },
  data() {
    return {
      loading:false
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.video-box {
  width: 100%;
  height: 100%;
}
video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
video::-webkit-media-controls-play-button {
  display: none;
}
video::-webkit-media-controls-current-time-display {
  display: none;
}
video::-webkit-media-controls-timeline {
  display: none;
}
.vie {
  width: 500px;
  height: 500px;
}
</style>
